const changeUploadStakeholdersMessage =
  'Are you sure you want to switch to another input method? Not saved stakeholders will be lost.';

export const methodOptions = [
  { label: 'Add Manually', value: 'manually' },
  { label: 'Bulk CSV Upload', value: 'csv' },
];

export const replaceOptions = [
  { label: 'Add new stakeholder to an existing structure', value: 'add' },
  { label: 'Replace existing structure', value: 'replace' },
];

export const stakeholderTypeOptions = [
  { label: 'Group', value: 'group' },
  { label: 'Individual', value: 'individual' },
];

export const defaultGroupStakeholder = {
  objectType: 'group',
};

const findEmailDuplicateIndexes = (arr) => {
  const seenEmails = {};
  const duplicatedIndices = [];

  arr.forEach((obj, index) => {
    const email = obj.email ? obj.email.trim() : null; // Remove leading/trailing spaces if not null

    if (email !== null && seenEmails[email] !== undefined) {
      duplicatedIndices.push(seenEmails[email]); // Add the first occurrence index
      seenEmails[email] = null; // Mark first occurrence index as null

      duplicatedIndices.push(index); // Add the current index
    } else if (email !== null) {
      seenEmails[email] = index; // Mark first occurrence index
    }
  });

  return duplicatedIndices;
};

const findGroupNameDuplicateIndexes = (arr) => {
  const seenNames = {};
  const duplicatedIndices = [];

  arr.forEach((obj, index) => {
    if (obj.objectType === 'group') {
      if (seenNames[obj.name] !== undefined) {
        if (seenNames[obj.name] !== null) {
          duplicatedIndices.push(seenNames[obj.name]);
          seenNames[obj.name] = null;
        }
        duplicatedIndices.push(index);
      } else {
        seenNames[obj.name] = index;
      }
    }
  });

  return duplicatedIndices;
};

export const validateStakeholdersManually = (stakeholdersStructure) => {
  const errors = {};

  stakeholdersStructure.map((stakeholder, index) => {
    if (stakeholder.objectType === 'group') {
      if (!stakeholder.name) {
        errors[`groupField.${index}.name`] = "Can't be blank";
      }
    }

    if (stakeholder.objectType === 'individual') {
      if (!stakeholder.firstName) {
        errors[`individualField.${index}.firstName`] = "Can't be blank";
      }
      if (!stakeholder.lastName) {
        errors[`individualField.${index}.lastName`] = "Can't be blank";
      }
      if (!stakeholder.email) {
        errors[`individualField.${index}.email`] = "Can't be blank";
      }
    }
  });

  const emailDuplicateIndexes = findEmailDuplicateIndexes([
    ...stakeholdersStructure,
  ]);

  if (emailDuplicateIndexes.length) {
    emailDuplicateIndexes.map((fieldIndex) => {
      if (fieldIndex === null) return;
      errors[
        `${stakeholdersStructure[fieldIndex].objectType}Field.${fieldIndex}.email`
      ] =
        'Email is already in use in the Stakeholder Organization Structure. Please change the Stakeholder email.';
    });
  }

  const groupNameDuplicateIndexes = findGroupNameDuplicateIndexes(
    stakeholdersStructure
  );

  if (groupNameDuplicateIndexes.length) {
    groupNameDuplicateIndexes.map((fieldIndex) => {
      errors[`groupField.${fieldIndex}.name`] = 'Name should be unique';
    });
  }

  return errors;
};

export const validateStakeholdersCsv = (formRef) => {
  const errors = {};

  if (!formRef.current) {
    errors.csv_file = 'CSV file is required';
  }

  return errors;
};

export const customProjectStatusesValidate = (values) => {
  const error = {};
  return error;
};

const findDuplicatedDraggableIds = (data) => {
  const result = [];

  Object.values(data).forEach((category) => {
    const nameCounts = {};
    const duplicates = new Set();

    category.forEach((item) => {
      const { name } = item;
      if (name) {
        nameCounts[name] = (nameCounts[name] || 0) + 1;
      }
    });

    Object.keys(nameCounts).forEach((name) => {
      if (nameCounts[name] > 1) {
        duplicates.add(name);
      }
    });

    category.forEach((item) => {
      if (duplicates.has(item.name)) {
        result.push(item.draggableId);
      }
    });
  });

  return result;
};

const findEmptyNameDraggableIds = (data) => {
  const emptyNames = [];

  Object.values(data).forEach((category) => {
    category.forEach((item) => {
      if (item.name === '') {
        emptyNames.push(item.draggableId);
      }
    });
  });

  return emptyNames;
};

export const validateInitiativeCategories = (values, columns) => {
  const duplicatedDraggableIds = findDuplicatedDraggableIds(columns);
  const emptyNameDraggableIds = findEmptyNameDraggableIds(columns);

  const errors = {};

  duplicatedDraggableIds.forEach((id) => {
    errors[id] = 'Duplicate Name';
  });

  emptyNameDraggableIds.forEach((id) => {
    errors[id] = "Name can't be blank";
  });

  return errors;
};

export const onStakeholdersUploadChange = (method, setUploadMethod) => {
  if (window.confirm(changeUploadStakeholdersMessage)) {
    setUploadMethod(method);
  }
};
